import env from "../../../config/env";
import { AxiosInstance } from "axios";
import { action, makeAutoObservable } from "mobx";
import http from "../../../services/http";
import { ServiceResult } from "../../../types/general-types";
import {
  CheckVerificationCodeRequestDto,
  CheckVerificationCodeResponseDto,
  LoginRequestDto,
  LoginResponseDto,
  SendVerificationCodeRequestDto,
  SendVerificationCodeResponseDto,
} from "./types";
import qs from "qs";
const { API_BASE_URL } = env;

class LoginStore {
  static readonly id: string = "LoginStore";

  get api(): AxiosInstance {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }

  constructor() {
    makeAutoObservable(this);
  }

  @action.bound async Login(params: LoginRequestDto) {
    const response: ServiceResult = await (
      await this.api.post(`/account/login`, params)
    ).data;
    return response;
  }

  @action.bound async SendVerificationCode(
    params: SendVerificationCodeRequestDto
  ) {
    const response: ServiceResult<SendVerificationCodeResponseDto> = await (
      await this.api.post(`/account/send-verification`, params)
    ).data;
    return response;
  }

  @action.bound async CheckVerificationCode(
    params: CheckVerificationCodeRequestDto
  ) {
    const response: ServiceResult<CheckVerificationCodeResponseDto> = await (
      await this.api.post(`/account/check-verification`, params)
    ).data;
    return response;
  }
}

export default LoginStore;
